export class Controllers {
  id!: number;
  nombreCategoria!: string;
  descripcion!: string;
  horaInicio!: string;
  horaFin!: string;
  diasAtencion!: string;
}
